import React, { memo, useCallback, useEffect, useState } from 'react';

import {
  VaccinationInfo,
  VaccinationStatusType,
  VaccinationStatusTypeColor,
  VaccinationStatusTypeText
} from 'src/types/IVaccination';
import { Dot, TRBody } from './styles';

interface IProps {
  checkbox: boolean;
  item: VaccinationInfo;
  isChecked: (id: number) => boolean;
  onClick?: (checked: boolean, item: any) => void;
}

const GridItem = ({ checkbox, item, onClick, isChecked }: IProps) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(isChecked(item.id));
  }, [isChecked, item.id]);

  const handleCheck = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setChecked(e.currentTarget.checked);
      if (onClick) onClick(e.currentTarget.checked, item);
    },
    [item, onClick]
  );

  const CheckBox = memo(() => {
    return (
      <>
        {checkbox ? (
          <td className='check'>
            <input
              type='checkbox'
              checked={checked}
              onChange={handleCheck}
              disabled={
                item.status === VaccinationStatusType.Canceled || item.status === VaccinationStatusType.Attended
              }
            />
          </td>
        ) : (
          ''
        )}
      </>
    );
  });

  return (
    <TRBody>
      <CheckBox />
      <td className='nowrap'>{item.user.fullName}</td>
      <td>{item.status === VaccinationStatusType.Rejected ? 'Não' : 'Sim'}</td>
      <td>
        {item?.scheduledDate ? new Date(item?.scheduledDate).toLocaleDateString('pt-BR', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric'
        }) : ''}
      </td>
      <td>
        {item.status === VaccinationStatusType.Scheduled || item.status === VaccinationStatusType.Attended
          ? 'Sim'
          : 'Não'}
      </td>
      <td className='nowrap'>
        <Dot color={VaccinationStatusTypeColor[item.status]} />
        {VaccinationStatusTypeText[item.status]}
      </td>
    </TRBody>
  );
};

export default GridItem;
